import { ENUM__ml_asset_family } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_family';
import { ENUM__ml_asset_type } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_type';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { DECORATOR__generation_tool_ml_asset_requirement } from '../_decorators/DECORATOR__generation_tool_ml_asset_requirement';
import { ENUM__graph_template_name } from './ENUM__graph_template_name';
import { GENERATION_TOOL__sd1__canny } from './views/GENERATION_TOOL__sd1__canny';
import { GENERATION_TOOL__sd1__color } from './views/GENERATION_TOOL__sd1__color';
import { GENERATION_TOOL__sd1__depth } from './views/GENERATION_TOOL__sd1__depth';
import { GENERATION_TOOL__sd1__grid2d_view__tune_text } from './views/GENERATION_TOOL__sd1__grid2d_view__tune_text';
import { GENERATION_TOOL__sd1__img2img } from './views/GENERATION_TOOL__sd1__img2img';
import { GENERATION_TOOL__sd1__reference_image_1 } from './views/GENERATION_TOOL__sd1__reference_image_1';
import { GENERATION_TOOL__sd1__reference_image_2 } from './views/GENERATION_TOOL__sd1__reference_image_2';
import { GENERATION_TOOL__sd1__select_loras } from './views/GENERATION_TOOL__sd1__select_loras';
import { GENERATION_TOOL__sd1__select_models } from './views/GENERATION_TOOL__sd1__select_models';
import { GENERATION_TOOL__sd1__select_vae } from './views/GENERATION_TOOL__sd1__select_vae';
import { GENERATION_TOOL__sd1__two_references } from './views/GENERATION_TOOL__sd1__two_references';

export class GENERATION_TOOL__sd1__master {
  @DECORATOR__generation_tool_ml_asset_requirement(ENUM__ml_asset_family.SD_1, ENUM__ml_asset_type.TEXT_ENCODER)
  @DECORATOR__generation_tool_ml_asset_requirement(ENUM__ml_asset_family.SD_1, ENUM__ml_asset_type.VAE)
  @DECORATOR__generation_tool_ml_asset_requirement(ENUM__ml_asset_family.SD_1, ENUM__ml_asset_type.UNET)
  static create() {
    let out = new DTO__generation_tool();
    out.name = ENUM__graph_template_name.GENERATE_SD_1;

    GENERATION_TOOL__sd1__grid2d_view__tune_text(out);

    if (out.graph.is_stub()) return DTO__generation_tool.CREATE_STUB();

    GENERATION_TOOL__sd1__img2img(out);

    GENERATION_TOOL__sd1__select_loras(out);

    GENERATION_TOOL__sd1__select_models(out);

    GENERATION_TOOL__sd1__select_vae(out);

    GENERATION_TOOL__sd1__reference_image_1(out);

    GENERATION_TOOL__sd1__reference_image_2(out);

    GENERATION_TOOL__sd1__two_references(out);

    GENERATION_TOOL__sd1__canny(out);

    GENERATION_TOOL__sd1__depth(out);

    GENERATION_TOOL__sd1__color(out);

    return out;
  }
}
